import { render, staticRenderFns } from "./AddStudentProfile.vue?vue&type=template&id=2a3bcd2a&"
import script from "./AddStudentProfile.vue?vue&type=script&lang=js&"
export * from "./AddStudentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddStudentProfile.vue"
export default component.exports